import { Button } from "@closer/ui";
import { Outlet, useNavigate } from "react-router";

import { useAuth } from "../../lib/authContext";

/**
 * Haricî katılımcı kabuğu (CLOS-147 `[128]`).
 *
 * ⚠ `AppLayout` DEĞİL ve olamaz: iç kabuk organizasyon sidebar'ını, çalışma alanı
 * değiştiriciyi ve iç menüleri taşıyor — kartın kuralı *"haricî görünüm organizasyon
 * sidebar'ını ... göstermez."* Bu kabuk yalnız ürün adı, hesap ve çıkış taşıyor; iç
 * dünyaya tek bir bağlantı bile yok.
 */
export function ExternalShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-canvas">
      <header className="border-b border-border-default bg-surface">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between px-4 py-3">
          <p className="font-semibold text-fg">Closer · Haricî erişim</p>
          <div className="flex items-center gap-3">
            <span className="text-sm text-fg-soft">{user?.email}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                void logout().then(() => navigate("/login"));
              }}
            >
              Çıkış
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1200px] px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
